import { useState } from 'react';

import AlertManager from "../Resources/AlertManager";
import NodeBackend from "../Resources/NodeBackend";
const backend = new NodeBackend();
const API_ENDPOINT = backend.getPath();

export function useSettingsManager() {
    const [user, setUser] = useState({});
    const [userId, setUserId] = useState(null);

      async function fetchUserAccess(uid) {
        try {
            const res = await fetch(`${API_ENDPOINT}check-access`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ uid })
            });
    
            const data = await res.json();
    
            if (!res.ok || data.status !== "succeed") {
                console.warn("Access check failed, defaulting to free.");
                return {
                    planType: "free",
                    trial: false,
                    hasSearchAccess: false,
                    hasTop10Access: false,
                    clubTier: "none"
                };
            }
    
            return data;
        } catch (err) {
            console.error("Error loading user access:", err);
            return {
                planType: "free",
                trial: false,
                hasSearchAccess: false,
                hasTop10Access: false,
                clubTier: "none"
            };
        }
    }

    async function loadUserAccess() {
        const uid = localStorage.getItem("userUid");

        // Se não tem UID → usuário "deslogado" / free
        if (!uid) {
            setUser({
                uid: null,
                planType: "free",
                trial: false,
                hasSearchAccess: false,
                hasTop10Access: false,
                clubTier: "none"
            });
            return;
        }

        const access = await fetchUserAccess(uid);
        // console.log("🔎 access from backend:", access);

        setUser({
            uid,
            planType: access?.planType || "free",
            trial: access?.trial === true,
            hasSearchAccess: access?.hasSearchAccess === true,
            hasTop10Access: access?.hasTop10Access === true,
            clubTier: access?.clubTier || "none"
        });
    }


    function formatDateToISO(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    function dateDifferenceInDays(startDate, endDate) {
        const millisecondsPerDay = 24 * 60 * 60 * 1000;
        const timeDifference = endDate - startDate;
        return Math.floor(timeDifference / millisecondsPerDay);
    }

    async function getUserFromStorage() {
        const email = localStorage.getItem('userEmail');
        const userUid = localStorage.getItem('userUid');
        const planType = localStorage.getItem('userPlanType');
        setUserId(userUid);
        setUser({ email: email, planType: planType });
    }

    async function handleSettingsPress() {
        const userId = localStorage.getItem('userUid');
        if (!userId) {
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "User not found",
                message: "Please log in again.",
                buttonText: "Got it!"
            });
            return;
        }

        try {
            const res = await fetch(
                `${API_ENDPOINT}create-settings-access`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ uid: userId }),
                }
            );

            const data = await res.json();

            if (!res.ok || data.status !== "success" || !data.url) {
                console.error("Error creating settings access:", data);
                AlertManager.show({
                    type: "error", // "error", "warning", or "message"
                    title: "Action failed",
                    message: "Could not load settings page. Please try again.",
                    buttonText: "Close"
                });
                return;
            }

            // ✅ Open only the URL returned by the backend
            // Check if current page comes from "app.nextstock.ca"
            const isFromApp = window.location.href.includes("app.nextstock.ca");

            const finalUrl = isFromApp
                ? `${data.url}${data.url.includes("?") ? "&" : "?"}source=app-nextstock`
                : data.url;

            window.open(finalUrl, "_self");
        } catch (error) {
            console.error("Unexpected error calling create-settings-access:", error);
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Unexpected error",
                message: "Please try again.",
                buttonText: "Close"
            });
        }
    }

    return { 
        user, 
        userId, 
        loadUserAccess,
        getUserFromStorage,
        formatDateToISO, 
        dateDifferenceInDays,
        handleSettingsPress
    };
}
